<script setup lang="ts">
import { onMounted } from 'vue';
import BaseIcon from '@/js/account/components/base/BaseIcon.vue';
import { classNames } from '@/js/lib/bem';
import { initMobileMenu } from '@/js/modules/mobile-menu';

const cn = classNames('header');

const homeAriaLabel
  = document.title.replace(/\s+—\s+Account$/i, '').trim() || 'Home';

onMounted(() => {
  initMobileMenu();
});
</script>

<template>
  <header :class="cn()">
    <div class="base-container header__container">
      <a href="/" class="header__logo" :aria-label="homeAriaLabel">
        <BaseIcon name="logo" :width="113" :height="48" />
      </a>
      <button
        type="button"
        class="header__menu-toggle js-mobile-menu-trigger"
        aria-label="Open menu"
        aria-controls="mobile-menu"
        aria-expanded="false"
      >
        <BaseIcon name="menu-alt" :width="24" :height="24" />
      </button>
      <a class="base-button base-button_theme_secondary header__login-button">Login</a>
    </div>
  </header>
</template>

<style lang="scss" scoped>
.header {
  &__container {
    max-width: none;
  }
}
</style>
